export default __webpack_public_path__ + "static/flatback-a77c1983c14ebd3bedd0786b195f9894.png";